// Curated tour packages — shown in the Packages section and selectable in the
// booking flow.
import { GM_IMAGES as I } from './images';

export const PACKAGES = [
  { title: '3 Days Serengeti Safari', img: I.lion, duration: '3 Days', price: '$1,450',
    rating: 4.9, reviews: 184, badge: 'Best Seller',
    desc: 'Dawn game drives, sundowners on the plains and a luxury tented camp under the stars.' },
  { title: '7 Days Northern Circuit', img: I.elephantsGold, duration: '7 Days', price: '$3,200',
    rating: 5.0, reviews: 96, badge: 'Signature',
    desc: 'Serengeti, Ngorongoro, Tarangire & Manyara — the complete Big Five expedition.' },
  { title: '5 Days Zanzibar Escape', img: I.zanzibar, duration: '5 Days', price: '$1,180',
    rating: 4.8, reviews: 142, badge: null,
    desc: 'Stone Town heritage, spice farms and barefoot days on the Indian Ocean.' },
  { title: 'Kilimanjaro Trekking', img: I.kilimanjaro, duration: '8 Days', price: '$2,650',
    rating: 4.9, reviews: 73, badge: 'Adventure',
    desc: 'Summit Uhuru Peak via the scenic Machame route with seasoned mountain guides.' },
  { title: 'Luxury Honeymoon Safari', img: I.giraffeSunset, duration: '6 Days', price: '$4,900',
    rating: 5.0, reviews: 58, badge: 'Luxury',
    desc: 'Private guide, fly-in camps and candle-lit bush dinners for two.' },
  { title: 'Ngorongoro & Manyara', img: I.elesPink, duration: '4 Days', price: '$1,720',
    rating: 4.8, reviews: 110, badge: null,
    desc: 'Descend into the crater and chase tree-climbing lions at Lake Manyara.' },
];

export default PACKAGES;
